import { Well, WellItem, WellLabel, WellBigNumber } from 'foundations-components/transitional/components/Well';
import { Link } from 'react-router-dom';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { NavMarker } from 'react-rhumb';
import { usePortalAggregations } from '../../myTeamQueries';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACTIVE_CERTIFICATIONS_BY_TEAM_PATH, IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH, EXPIRED_CERTIFICATIONS_BY_TEAM_PATH } from '../../constants/routes';
import ExpiringSoonHelpIcon from '../common/ExpiringSoonHelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonBox = () => {
  return /*#__PURE__*/_jsx(ACSkeletonBox, {
    animated: true,
    style: {
      width: '36px',
      height: '32px'
    }
  });
};
const CertificationsTotals = () => {
  const {
    portalAggregations,
    portalAggregationsLoading
  } = usePortalAggregations();
  if (!portalAggregationsLoading && !(portalAggregations !== null && portalAggregations !== void 0 && portalAggregations.totals)) {
    return null;
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "CERTIFICATION_TOTALS_BY_TOPIC_LOADED",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      compact: true,
      children: /*#__PURE__*/_jsxs(Well, {
        children: [/*#__PURE__*/_jsxs(WellItem, {
          children: [/*#__PURE__*/_jsx(WellLabel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.certifications.totals.active"
            })
          }), /*#__PURE__*/_jsx(WellBigNumber, {
            children: portalAggregationsLoading ? /*#__PURE__*/_jsx(SkeletonBox, {}) : /*#__PURE__*/_jsx(Link, {
              to: ACTIVE_CERTIFICATIONS_BY_TEAM_PATH,
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: (portalAggregations === null || portalAggregations === void 0 ? void 0 : portalAggregations.totals.active) || 0
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(WellItem, {
          children: [/*#__PURE__*/_jsxs(WellLabel, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.certifications.totals.expiringSoon"
            }), ' ', /*#__PURE__*/_jsx(ExpiringSoonHelpIcon, {})]
          }), /*#__PURE__*/_jsx(WellBigNumber, {
            children: portalAggregationsLoading ? /*#__PURE__*/_jsx(SkeletonBox, {}) : /*#__PURE__*/_jsx(Link, {
              to: `${ACTIVE_CERTIFICATIONS_BY_TEAM_PATH}?sortBy=EXPIRES_AT&sortDir=ASC`,
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: (portalAggregations === null || portalAggregations === void 0 ? void 0 : portalAggregations.totals.expiringSoon) || 0
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(WellItem, {
          children: [/*#__PURE__*/_jsx(WellLabel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.certifications.totals.expired"
            })
          }), /*#__PURE__*/_jsx(WellBigNumber, {
            children: portalAggregationsLoading ? /*#__PURE__*/_jsx(SkeletonBox, {}) : /*#__PURE__*/_jsx(Link, {
              to: EXPIRED_CERTIFICATIONS_BY_TEAM_PATH,
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: (portalAggregations === null || portalAggregations === void 0 ? void 0 : portalAggregations.totals.expired) || 0
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(WellItem, {
          children: [/*#__PURE__*/_jsx(WellLabel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.certifications.totals.inProgress"
            })
          }), /*#__PURE__*/_jsx(WellBigNumber, {
            children: portalAggregationsLoading ? /*#__PURE__*/_jsx(SkeletonBox, {}) : /*#__PURE__*/_jsx(Link, {
              to: IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH,
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: (portalAggregations === null || portalAggregations === void 0 ? void 0 : portalAggregations.totals.inProgress) || 0
              })
            })
          })]
        })]
      })
    })
  });
};
export default CertificationsTotals;